export var CURRENT_MENU_ITEM_POSITION = 'CURRENT_MENU_ITEM_POSITION';
export var CURRENT_PARENT_MENU_ITEM_POSITION = 'CURRENT_PARENT_MENU_ITEM_POSITION';
